import { LitElement, html, svg } from 'lit';

export class IconNoSmoking24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Overstreket sigarett</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18.5 9.25h3.25a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-9.22M5.25 15.25h-1.5v-6h7.455M.75 9.25v6M.75 23.25 23.25.75M.75 5.25a1.5 1.5 0 0 1 1.5-1.5A3 3 0 0 0 5.248.871"></path></svg>`; }
}
if (!customElements.get('f-icon-no-smoking24', IconNoSmoking24)) {
  customElements.define('f-icon-no-smoking24', IconNoSmoking24);
}